exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment[data-v-cba236dc]{margin-bottom:10px;background:#f3f3f3}", ""]);

// exports
